import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "api";
import { STATUS } from "utils/status";
import { taskDataProps, UploadPayload } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/taskDataExtraReducer';

const initialState: taskDataProps = {
  taskData: {
    message: '',
    data: {},
    error: null
  },
  error: null,
  getTaskDataStatus: STATUS.NOT_STARTED,
  getTaskDataMessage: ""
};


export const getTaskData = createAsyncThunk(
  'project/company/export/get',
  async (payload: UploadPayload = { project_id: '' }, thunkAPI) => {
    try {
      const { project_id, association_type } = payload;
      const response = await api.get('project/company/export', {
        params: {
          ...(project_id && { project_id }),
          ...(association_type && { association_type }),
        },
      });
      const { status, data } = response;
      if (status === 202) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {      
        return thunkAPI.rejectWithValue({ message: error.message });
    }
  }
);



const taskDataSlice = createSlice({
  name: 'taskData',
  initialState,
  reducers: {
    setGetTaskDataStatus(state, action) {
      state.getTaskDataStatus = action.payload
    },
  },

  extraReducers
});


export const { setGetTaskDataStatus } = taskDataSlice.actions
export default taskDataSlice.reducer;

